import { useFormikContext } from "formik";
import React from "react";
import { getFieldPath, getToggleProps } from "utils/form";
import Toggle from "react-toggle";
import { STATE_KEYS } from "utils/constants/state";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import set from "lodash/set";
import classnames from "classnames";
import { omitDeep } from "utils/data";

const ShippingWorldwideToggle = ({ name, active, error }) => {
  const { values, touched, setValues, setFieldTouched } = useFormikContext();
  const shippingWorldwidePath = getFieldPath(name, "shipping_worldwide");

  return (
    <div
      className={classnames("flex flex-row justify-between items-center pt3", {
        "pb3 bb hairline-1": !active
      })}
    >
      <label
        className={classnames("f6 fw5 db", {
          "color-error": error
        })}
      >
        Worldwide
      </label>

      <Toggle
        {...getToggleProps({
          active,
          setFieldValue: (_, updatedActive) => {
            if (!get(touched, shippingWorldwidePath)) {
              setFieldTouched(shippingWorldwidePath, true);
            }

            setTimeout(() => {
              /**
               * If updated value is true then remove allowed countries attribute
               * Then set updated value on the shipping worldwide path
               */
              const updatedValues = updatedActive
                ? omitDeep(
                    values,
                    STATE_KEYS.SHORT_LINK.SHIPPING_ALLOWED_COUNTRIES
                  )
                : cloneDeep(values);
              set(updatedValues, shippingWorldwidePath, updatedActive);
              setValues(updatedValues);
            }, 0);
          }
        })}
      />
    </div>
  );
};

export default ShippingWorldwideToggle;
